import { useBulkActionsStateContext } from '../contexts/bulkActionsContext';
export const useBulkActionsState = () => {
  const state = useBulkActionsStateContext();
  return state;
};